import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { setDeveloperToken, setDriftToken, removeAllTokens } from 'services/tokenService'
import { fetchDeveloperToken } from 'api/authApi'
import ConditionalRender from 'components/ConditionalRender'
import { authenticateWithCode, getAccessToken, redirectToLoginPage, constructUrlObjectWithoutAuthParams } from '@driftt/web-auth'
import config from 'config'
import urlParse from 'url-parse'

const DO_PARSE_QUERY = true
const parseUrl = (location) => urlParse(`${location.pathname}${location.search}`, DO_PARSE_QUERY)

class AuthHandler extends Component {
  state = {
    canProceed: false
  }

  componentWillMount() {
    this.tryFetchAccessTokens()
  }

  tryFetchAccessTokens = () => {
    const parsedUrl = parseUrl(this.props.location)

    if (parsedUrl.query.code) {
      this.handleAuthCode(parsedUrl)
    } else if (parsedUrl.query.token) {
      this.handleAccessToken(parsedUrl)
    } else if (parsedUrl.pathname === '/logout') {
      this.handleLogout(parsedUrl)
    } else if (!!getAccessToken()) {
      fetchDeveloperToken(getAccessToken())
        .then(setDeveloperToken)
        .then(this.proceedToRoute)
    } else {
      this.proceedToRoute()
    }
  }

  handleAuthCode = (parsedUrl) => {
    const proceed = () => {
      const nextUrl = this.resolveNextUrl(parsedUrl)
      this.props.history.push(nextUrl)
      this.proceedToRoute()
    }

    const onAccessTokenResolved = () => {
      return fetchDeveloperToken(getAccessToken())
        .then(setDeveloperToken)
    }

    removeAllTokens()

    authenticateWithCode({ authorizationCode: parsedUrl.query.code, clientId: config.AUTH_CLIENT_ID })
      .then(onAccessTokenResolved)
      .then(proceed)
      .catch(() => redirectToLoginPage(config.AUTH_CLIENT_ID))
  }

  handleLogout = (parsedUrl) => {
    const nextUrl = this.resolveNextUrl(parsedUrl)
    this.props.history.push(nextUrl)

    removeAllTokens()
    this.proceedToRoute()
  }

  handleAccessToken = (parsedUrl) => {
    const onTokenFetched = (developerToken) => {
      setDriftToken(parsedUrl.query.token)
      setDeveloperToken(developerToken)

      const nextUrl = this.resolveNextUrl(parsedUrl)
      this.props.history.push(nextUrl)
      this.proceedToRoute()
    }

    removeAllTokens()
    fetchDeveloperToken(parsedUrl.query.token)
      .then(onTokenFetched)
      .catch(() => redirectToLoginPage(config.AUTH_CLIENT_ID))
  }

  resolveNextUrl = (parsedUrl) => {
    const { location } = this.props
    const cleanUrl = constructUrlObjectWithoutAuthParams(location)
    const relativeUrl = cleanUrl.href.replace(parsedUrl.origin, '')
    return relativeUrl
  }

  proceedToRoute = () => {
    this.setState({ canProceed: true })
  }

  render() {
    const { children } = this.props
    const { canProceed } = this.state

    return (
      <ConditionalRender condition={canProceed}>
        {children}
      </ConditionalRender>
    )
  }
}

export default withRouter(AuthHandler)
